import React from "react";

const CvTemplate = ({ onClose }) => (
  <div className="cvtemplate_pos">
    <div className="cvtemplate_bg">
      <div className="cvtemplate_content">
        <button onClick={onClose} className="close_btn">
          <img src="/assets/images/cross.svg" alt="" />
        </button>
        <h3>CV Mandatory information:</h3>
        
      </div>
      <ol className="cvtemplate_list">
        <li>Name</li>
        <li>Date of Birth</li>
        <li>Address</li>
        <li>Email ID</li>
        <li>Phone no</li>
        <li>Educational Qualifications (Degree, Field of Study, Institution Name, and Graduation Year)</li>
        <li>Work Experience (Title/Position, Organization Name, Start Month/Year, and End Month/Year)</li>
        <li>Publications - Books, Book Chapters, Research Journals, Op-Eds, Interviews, Conference Proceedings, Digital Media Interventions, etc. (Publication Type, Title, Published in info, Year of Publication) </li>
        <li>Awards/ Honors/Scholarships/Fellowships, if any (in descending order)</li>
        <li>Any Other Information</li>
      </ol>
    </div>
  </div>
);

export default CvTemplate;
